import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Plus, Calendar, Users, Euro, Trash2 } from "lucide-react";
import { toast } from "sonner";
import BillingBanner from "@/components/BillingBanner";
import MagicEventButton from "@/components/MagicEventButton";

const fmtEur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;
const TYPE_LABEL = { matrimonio: "Matrimonio", addio_celibato: "Addio celibato", addio_nubilato: "Addio nubilato", laurea: "Laurea", compleanno: "Compleanno", battesimo: "Battesimo", cresima: "Cresima", comunione: "Comunione", fidanzamento: "Fidanzamento", cenone_capodanno: "Cenone di Capodanno", pranzo_natale: "Pranzo di Natale", pranzo_pasqua: "Pranzo di Pasqua", pranzo_pasquetta: "Pranzo di Pasquetta", pranzo_ferragosto: "Pranzo di Ferragosto", cena_ferragosto: "Cena di Ferragosto", altro: "Altro" };

export default function Events() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  const load = () => api.get("/events").then((r) => setEvents(r.data));
  useEffect(() => { load(); }, []);

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Eliminare l'evento?")) return;
    await api.delete(`/events/${id}`);
    toast.success("Evento eliminato");
    load();
  };

  return (
    <div className="space-y-8" data-testid="events-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#2563EB] font-semibold font-ui">Eventi</p>
          <h1 className="font-display text-4xl md:text-5xl text-[#0F2741] tracking-tight mt-2">I tuoi eventi</h1>
          <p className="text-slate-500 mt-2">{events.length} eventi totali</p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <MagicEventButton />
          <button onClick={() => navigate("/eventi/nuovo")} data-testid="btn-new-event" className="btn-primary"><Plus className="w-4 h-4" /> Nuovo evento</button>
        </div>
      </div>

      <BillingBanner />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {events.length === 0 && (
          <div className="col-span-full bg-white rounded-xl border border-dashed border-slate-300 p-12 text-center">
            <Calendar className="w-12 h-12 mx-auto text-slate-300 mb-2" />
            <p className="text-slate-500 mb-4">Nessun evento ancora. Inizia la pianificazione!</p>
            <button onClick={() => navigate("/eventi/nuovo")} className="btn-primary">Crea il primo evento</button>
          </div>
        )}
        {events.map((e) => (
          <div key={e.id} onClick={() => navigate(`/eventi/${e.id}`)} className="bg-white rounded-xl border border-slate-200 p-5 card-hover cursor-pointer">
            <div className="flex items-start justify-between">
              <div>
                <span className="text-xs uppercase tracking-wider text-[#2563EB] font-semibold">{TYPE_LABEL[e.event_type]}</span>
                <h3 className="font-display text-xl text-[#0F2741] mt-1">{e.client_name || "Senza nome"}</h3>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full uppercase tracking-wider font-semibold ${
                e.status === "approved" ? "bg-emerald-100 text-emerald-700" :
                e.status === "rejected" ? "bg-rose-100 text-rose-700" :
                e.status === "quoted" ? "bg-blue-100 text-blue-700" :
                "bg-amber-100 text-amber-700"
              }`}>{
                e.status === "approved" ? "Accettato" :
                e.status === "rejected" ? "Rifiutato" :
                e.status === "quoted" ? "Inviato" :
                e.status
              }</span>
            </div>
            <div className="mt-4 space-y-1 text-sm text-slate-600">
              <p className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-slate-400" /> {e.event_date || "data da definire"}</p>
              <p className="flex items-center gap-2"><Users className="w-3.5 h-3.5 text-slate-400" /> {e.guests} ospiti</p>
              <p className="flex items-center gap-2"><Euro className="w-3.5 h-3.5 text-slate-400" /> {fmtEur(e.final_price)}</p>
            </div>
            <div className="mt-4 pt-3 border-t border-slate-100 flex justify-end">
              <button onClick={(ev) => handleDelete(e.id, ev)} className="text-slate-400 hover:text-rose-500"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
